// networkingToaster.js
import pushToastr from '../action/pushToastr.js';
import { SET_NETWORKING_ERROR } from '../ActionTypes.js';
import { BindEmail } from '../resource/authEntryType.js';
import getTranslationKey from '../resource/getTranslationKey.js';

/**
 * create the redux middleware to push networking error toastr
 * @return {import("redux").Middleware}
 */
const networkingToaster = store => next => action => {
  if (SET_NETWORKING_ERROR === action.type) {
    try {
      const { status, pathname, code } = JSON.parse(
        action.payload.error.message
      );

      let textKey = '';
      if (!status) {
        textKey = 'cannot_send_request_error';
      } else if (401 === status) {
        import('../action/logout.js').then(({ default: logout }) => {
          store.dispatch(logout({ via: 'expired' }));
        });
      } else if (403 === status && code === 'INSUFFICIENT_FUNDS') {
        textKey = 'error_insufficient_funds';
        import('../action/addvalue.js').then(({ default: addvalue }) => {
          store.dispatch(addvalue({ via: 'insuficient' }));
        });
      } else if (403 === status && code === 'KYC_REQUIRED') {
        import('../action/openBindPhoneModal.js').then(
          ({ default: openBindPhoneModal }) => {
            store.dispatch(openBindPhoneModal());
          }
        );
      } else if (403 === status && code === 'MISSING_EMAIL') {
        import('../action/openBindEmailModal.js').then(
          ({ default: openBindEmailModal }) => {
            store.dispatch(
              openBindEmailModal({
                canClose: true,
                entry: BindEmail.BINDING_ALERT,
              })
            );
          }
        );
      } else if (403 === status && code === 'TURNSTILE_REQUIRED') {
        textKey = 'racaptcha_varify_error';
      } else if (429 === status) {
        textKey = 'alert_over_the_rate_limit';
      } else if (code) {
        textKey = getTranslationKey({
          key: `error_${code}`,
        });
      } else if (500 <= status && 600 > status) {
        textKey = 'something_went_wrong';
      }

      if (textKey) {
        let attachedMessage = '';
        if (status && pathname) {
          attachedMessage = ` (${status}, ${pathname})`;
        } else if (status) {
          attachedMessage = `(${status})`;
        }
        store.dispatch(
          pushToastr({ textKey, attachedMessage, color: 'error' })
        );
      }
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
  return next(action);
};

export default networkingToaster;
